import { BreadcrumbsHeader } from "@/components/breadcrumbs-header";
import { SidebarTrigger } from "@/components/ui/sidebar";
import type { BreadcrumbItem as BreadcrumbItemType } from "@/types";
import { Separator } from "@/components/ui/separator";

export function AppSidebarHeader({
  breadcrumbs,
}: {
  breadcrumbs: BreadcrumbItemType[];
}) {
  return (
    <header className="flex min-h-16 shrink-0 items-center gap-2">
      <div className="flex min-w-0 items-center gap-2 px-page">
        <SidebarTrigger className="-ml-1 size-11 shrink-0 md:size-9" />
        {breadcrumbs.length > 0 && (
          <>
            <Separator
              orientation="vertical"
              className="mr-2 data-vertical:h-4 data-vertical:self-center"
            />
            <BreadcrumbsHeader breadcrumbs={breadcrumbs} />
          </>
        )}
      </div>
    </header>
  );
}
